/**会话缓存-网络请求 */
export const CACHE_SESSION_AXIOS = 'cache:session:axios';

/**本地缓存-布局设置 */
export const CACHE_LOCAL_LAYOUTCONFIG = 'cache:local:layoutConfig';
